module.exports = __webpack_public_path__ + "static/img/Solutionimg1.698e6f49.jpg";